import React, { useState, useEffect } from 'react';
import BlogCard from '../components/BlogCard';
import { blogAPI } from '../services/api';
import ScrollReveal, { RevealUp, RevealLeft, RevealRight, RevealScale, StaggeredReveal } from '../components/ScrollReveal';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('सभी');
  const [pagination, setPagination] = useState({ page: 1, pages: 1 });

  const categories = ['सभी', 'रामकथा', 'मिथिला संस्कृति', 'त्योहार', 'धार्मिक शिक्षा', 'सामान्य'];

  useEffect(() => {
    fetchBlogs();
  }, [selectedCategory]);

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const params = selectedCategory !== 'सभी' ? `?category=${encodeURIComponent(selectedCategory)}` : '';
      const response = await blogAPI.getAll(params ? { category: selectedCategory } : {});
      const data = response.data;
      setBlogs(data.blogs || data || []);
      if (data.pagination) setPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredBlogs = blogs;

  if (loading) {
    return (
      <div className="min-h-screen bg-mithila-bg flex items-center justify-center">
        <div className="text-center">
          <div className="loader mb-4"></div>
          <p className="text-mithila-text">ब्लॉग लोड हो रहे हैं...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-temple-bg">
      {/* Header */}
      {/* <section className="py-20 bg-gradient-to-r from-temple-accent to-temple-primary text-white">
        <RevealUp className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-6">
            ब्लॉग
          </h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
            धार्मिक कथाएं, सांस्कृतिक जानकारी और आध्यात्मिक शिक्षा
          </p>
        </RevealUp>
      </section> */}

      {/* Category Filter */}
      <section className="py-5 bg-white border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-5">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-bold transition-all duration-200 ${
                  selectedCategory === category
                    ? 'bg-temple-primary text-white shadow-lg transform scale-105'
                    : 'bg-temple-bg text-temple-text hover:bg-gray-100 border border-gray-200 hover:scale-105'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-5">
          {filteredBlogs.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredBlogs.map((blog, index) => (
                <ScrollReveal
                  key={`${blog._id}-${selectedCategory}`}
                  animation="up"
                  delay={index * 100}
                  triggerOnce={false}
                  className="h-full"
                >
                  <BlogCard blog={blog} />
                </ScrollReveal>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="text-6xl mb-4 text-gray-400">
                <i className="fas fa-blog"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-600 mb-2">
                कोई ब्लॉग उपलब्ध नहीं
              </h3>
              <p className="text-gray-500">
                इस श्रेणी में अभी तक कोई ब्लॉग प्रकाशित नहीं किया गया है।
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Featured Quote */}
      <section className="py-10 bg-white">
        <RevealScale className="max-w-3xl mx-auto px-4 sm:px-5 text-center">
          <div className="bg-temple-bg rounded-3xl p-8 border border-temple-secondary/20">
            <div className="text-4xl mb-4 text-temple-primary">
              <i className="fas fa-book-open"></i>
            </div>
            <blockquote className="text-xl font-serif text-temple-text mb-4 italic">
              "ज्ञान ही सच्चा धन है, और धर्म ही सच्चा मार्ग है।"
            </blockquote>
            <p className="text-sm text-gray-600">
              - श्रीमद्भगवद्गीता
            </p>
          </div>
        </RevealScale>
      </section>

      {/* Newsletter Signup */}
      <section className="py-10 bg-temple-accent text-white">
        <RevealUp className="max-w-3xl mx-auto px-4 sm:px-5 text-center">
          <h3 className="text-2xl font-serif font-bold mb-4">
            नवीनतम ब्लॉग की जानकारी पाएं
          </h3>
          <p className="text-gray-200 mb-6">
            हमारे नए ब्लॉग और धार्मिक जानकारी के लिए सदस्यता लें।
          </p>
          <ScrollReveal animation="scale" delay={300}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <input
                type="email"
                placeholder="आपका ईमेल पता"
                className="flex-1 px-4 py-3 rounded-lg text-temple-text"
              />
              <button className="bg-temple-secondary text-temple-text px-6 py-3 rounded-lg font-bold hover:bg-yellow-400 transition">
                सदस्यता लें
              </button>
            </div>
          </ScrollReveal>
        </RevealUp>
      </section>
    </div>
  );
};

export default Blog;